import { motion } from "framer-motion";
import { AppLayout } from "../../../layout/AppLayout";
import {
  Achievement,
  Crown,
  Live,
  Profile,
} from "../../../components/svg/GeneralIcons";
import WorldAchievementUI from "../../../modules/world/rmc/achievements/achievmentsUI";
import Header from "../../../components/world/rmc/Header";
import { RmcContext } from "../../../components/context/RmcContext";
import { useContext, useEffect } from "react";
import { UserContext } from "../../../components/context/UseContext";
import { useGenerateBrand } from "../../../api/useGenerateBrand";
import { FaPlane } from "react-icons/fa";
import { Loader } from "../../../components/loader/Loader";

function WorldAchievements() {
  const { token } = useContext(UserContext);
  const { brandId, slug, worldBranch } = useContext(RmcContext);

  const {
    generateBrand,
    data: brandData,
    loading: isPending,
  } = useGenerateBrand();

  const primaryColor = brandData?.data?.brand?.secondary_color ?? "#FFD700";

  useEffect(() => {
    if (brandId) {
      generateBrand({
        token: token,
        brand_id: brandId,
        is_link: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId]);

  if (isPending) {
    return (
      <div className="h-[100dvh] bg-[#111522] flex items-center justify-center">
        <Loader type="spinningBubbles" color="#fff" />
      </div>
    );
  }

  return (
    <AppLayout
      bg={"!bg-[#111522]"}
      navBg={"!bg-[#111522]"}
      firstText={brandData?.data?.brand?.name ?? "Kingdom Quest"}
      secondText={"I'm Live"}
      thirdText={"Achievements"}
      fourthText={"Profile"}
      firstIcon={
        brandData?.data?.brand?.name?.toLowerCase().includes("airpeace") ? (
          <FaPlane className="w-5 h-5 -rotate-45" />
        ) : (
          <Crown className={"w-5 h-5"} />
        )
      }
      secondIcon={<Live className={"w-5 h-5"} />}
      thirdIcon={<Achievement className={"w-5 h-5"} />}
      fourthIcon={<Profile className={"w-5 h-5"} />}
      activeColor={brandData?.data?.brand?.secondary_color ?? "#FFD700"}
      inactiveClass={"text-[#FFFFFFBF]"}
      firstLink={`${slug}/home`}
      secondLink={`${slug}/live${
        worldBranch?.value ? `?branch_id=${worldBranch.value}` : ""
      }`}
      thirdLink={`${slug}/achievements`}
      fourthLink={`${slug}/profile`}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 3, delay: 0.4 }}
        className="relative pb-20"
      >
        <motion.div className="relative rounded-b-[25px]">
          <Header customBgColor={primaryColor} />
        </motion.div>

        <motion.h3
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className=" text-2xl font-semibold text-white mx-0 "
        >
          <WorldAchievementUI primaryColor={primaryColor} />
        </motion.h3>
      </motion.div>
    </AppLayout>
  );
}

export default WorldAchievements;
